import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { EBillLocationsActions, fromEBillLocations } from '@ruby/modules/ebill/store/ebill-locations.index';
import { selectBillLocationState } from '@ruby/modules/ebill/store/selectors/ebill-locations.selectors';
import { EBillRouteEnum } from '@ruby/shared/enums/ebill.enums';
import { ITransaction } from '@ruby/shared/models/commons/transaction.interface';
import { IEBillCustomerSearch, IEBillLocationCodes } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-locations-container',
  template: `
    <ng-ebill-locations-component *ngIf="(store$ | async) as store"
                                  [loading]="store.state.loading"
                                  [data]="store.state.customers"
                                  [selectedCustomer]="store.state.customers[0]"
                                  [userRacf]="store.userRacf"
                                  (navigate)="dispatchUpdateLocationAction($event)"
    >
    </ng-ebill-locations-component>
  `
})
export class EBillLocationContainer implements OnDestroy {
  store$: Observable<{ state: fromEBillLocations.State; userRacf?: string }>;
  private acrSubscription!: Subscription;

  constructor(private store: Store<fromEBillLocations.State>, private acr: ActivatedRoute) {
    this.store$ = store.select(selectBillLocationState);
    this.parseTransaction();
  }

  ngOnDestroy(): void {
    this.acrSubscription.unsubscribe();
  }

  /**
   * dispatchUpdateLocationAction
   *
   * @summary dispatch Update LocationAction selected locations
   * @param $event: ({ locations: IEBillLocationCodes; route: EBillRouteEnum })
   * @returns void
   */
  dispatchUpdateLocationAction($event: { locations: IEBillLocationCodes; route: EBillRouteEnum }): void {
    this.store.dispatch(EBillLocationsActions.updateLocations({ data: $event }));
  }

  private parseTransaction(): void {
    this.acrSubscription = this.acr.data.pipe(
      map((data: Data) => data.transaction)
    ).subscribe((transaction: ITransaction) => {
      if (transaction) {
        this.load(JSON.parse(transaction.parameters.eBill!) as IEBillCustomerSearch);
      }
    });
  }

  private load(data: IEBillCustomerSearch): void {
    this.store.dispatch(EBillLocationsActions.loadLocations({ data }));
  }
}
